import { Injectable } from '@angular/core';
import { IdentitePatch } from '../models/identite-patch.model';
import { CarteTPatch } from '../models/carte-t-patch.model';
import { StatutJuridiqueSocietePatch } from '../models/statut-juridique-societe-patch.model';
import { StatutJuridiqueProfessionLiberalePatch } from '../models/statut-juridique-profession-liberale-patch';
import { CoordonneesPatch } from '../models/coordonnees-patch.model';
import { PieceJustificativeRcpPatch } from '@lib/models/demande-validation-pj/piece-justificative-rcp.model';
import { PieceJustificativeRsac } from '@lib/models/demande-validation-pj/piece-justificative-rsac.model';
import { PieceJustificativeKbis } from '@lib/models/demande-validation-pj/piece-justificative-kbis.model';
import { PieceJustificativeAttVig } from '@lib/models/demande-validation-pj/piece-justificative-att-vig.model';
import { PieceJustificativeCerfa } from '@lib/models/demande-validation-pj/piece-justificative-cerfa.model';
import { PieceJustificativeNotifAff } from '@lib/models/demande-validation-pj/piece-justificative-notif-aff.model';
import { PieceJustificativeNotifDelaiUrssaf } from '@lib/models/demande-validation-pj/piece-justificative-notif-delai-urssaf.model';
import { PieceJustificativeSyntUrssaf } from '@lib/models/demande-validation-pj/piece-justificative-synt-urssaf.model';

@Injectable({ providedIn: 'root' })
export abstract class ControleDocumentsService {
  abstract editIdentite(publicId: string, patch: IdentitePatch): Promise<void>;
  abstract editCoordonnees(publicId: string, patch: CoordonneesPatch): Promise<void>;
  abstract editActiviteImmobiliere(publicId: string, patch: CarteTPatch): Promise<void>;
  abstract editStatutJuridiqueSociete(
    publicId: string,
    patch: StatutJuridiqueSocietePatch
  ): Promise<void>;
  abstract editStatutJuridiqueProfessionLiberale(
    publicId: string,
    patch: StatutJuridiqueProfessionLiberalePatch
  ): Promise<void>;
  abstract editInformationsRcp(
    publicId: string,
    patch: PieceJustificativeRcpPatch
  ): Promise<void>;
  abstract editInformationsRsac(
    publicId: string,
    patch: PieceJustificativeRsac
  ): Promise<void>;
  abstract editInformationsKbis(
    publicId: string,
    patch: PieceJustificativeKbis
  ): Promise<void>;
  abstract editInformationsAttVig(
    publicId: string,
    patch: PieceJustificativeAttVig
  ): Promise<void>;
  abstract editInformationsCerfa(
    publicId: string,
    patch: PieceJustificativeCerfa
  ): Promise<void>;
  abstract editInformationsNotifAff(
    publicId: string,
    patch: PieceJustificativeNotifAff
  ): Promise<void>;
  abstract editInformationsSyntUrssaf(
    publicId: string,
    patch: PieceJustificativeSyntUrssaf
  ): Promise<void>;
  abstract editInformationsNotifDelaiUrssaf(
    publicId: string,
    patch: PieceJustificativeNotifDelaiUrssaf
  ): Promise<void>;
}
